import { Fragment } from 'react'
import OmpCard from './OmpCard'

type Variant = 'order' | 'subscription' | 'rows'

interface OmpSkeletonCardProps {
  count?: number
  variant?: Variant
}

const productRow = (
  <div className="omp-sub-card-product">
    <div className="omp-sub-card-img">
      <span className="skeleton omp-skel-fill" />
    </div>
    <div className="omp-sub-card-text flex-1">
      <span className="skeleton omp-skel-line omp-skel-line-md omp-skel-w-70" />
      <span className="skeleton omp-skel-line omp-skel-w-45" />
      <span className="skeleton omp-skel-line omp-skel-w-35" />
    </div>
  </div>
)

const actions = (
  <>
    <span className="skeleton omp-skel-btn" />
    <span className="skeleton omp-skel-btn" />
  </>
)

// Built from the same classes as OmpOrderCard / OmpSubscriptionCard, so the swap to real
// content lands on the same grid, paddings and thumbnail box.
const OmpSkeletonCard = ({ count = 3, variant = 'order' }: OmpSkeletonCardProps) => {
  return (
    <div className="omp-card-list" aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => {
        if (variant === 'rows') {
          return (
            <OmpCard key={i} className="omp-card-padded omp-skel">
              <div className="omp-skel-lines">
                <span className="skeleton omp-skel-line omp-skel-w-45" />
                <span className="skeleton omp-skel-line omp-skel-w-70" />
                <span className="skeleton omp-skel-line omp-skel-w-35" />
              </div>
            </OmpCard>
          )
        }

        if (variant === 'subscription') {
          return (
            <OmpCard key={i} className="omp-sub-card">
              <div className="omp-sub-card-main">
                <div className="omp-sub-card-info">
                  <div className="omp-sub-card-meta-head">
                    <span className="skeleton omp-skel-line omp-skel-line-md omp-skel-w-45" />
                    <span className="skeleton omp-skel-line omp-skel-w-35" />
                  </div>
                  {productRow}
                </div>
                <div className="omp-sub-card-actions">{actions}</div>
              </div>
            </OmpCard>
          )
        }

        // Second card shows two rows — an order holding several items is the case whose
        // height the swap most needs to match.
        const rows = i === 1 ? 2 : 1
        return (
          <OmpCard key={i} className="omp-order-card">
            <div className="omp-order-card-meta">
              <div className="omp-order-card-head">
                <span className="skeleton omp-skel-line omp-skel-line-md omp-skel-w-45" />
                <span className="skeleton omp-skel-pill" />
              </div>
              <span className="skeleton omp-skel-line omp-skel-w-35" />
            </div>
            <div className="omp-order-card-rows">
              {Array.from({ length: rows }).map((_, row) => (
                <Fragment key={row}>
                  {row > 0 && <hr className="omp-order-card-rule" />}
                  <div className="omp-order-card-row">
                    {productRow}
                    <div className="omp-order-card-actions">{actions}</div>
                  </div>
                </Fragment>
              ))}
            </div>
            <div className="omp-order-card-foot">
              <div className="omp-order-card-total">
                <span className="skeleton omp-skel-line omp-skel-w-35" />
                <span className="skeleton omp-skel-line omp-skel-w-25" />
              </div>
            </div>
          </OmpCard>
        )
      })}
    </div>
  )
}

export default OmpSkeletonCard
